import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { Order, OrderStatus } from "../proto/generated/order"
import { OrdersStateType } from "../reducer/orders.reducer"
import { Position } from "../proto/generated/position"
const state = (state: RootState) => state.ordersStore as OrdersStateType


export const selectOrdersData = createDraftSafeSelector(state, (store) => store)
export const selectOrdersHistory = createDraftSafeSelector(state, (store) => (store?.ordersHistory??[]) as Order[])
export const getNoOfOpenOrders = createDraftSafeSelector(state, (store) => {
    const orders = store.ordersHistory
    return orders?.filter((o) => o.status === OrderStatus.OPEN).length ?? 0
})
export const getNoOfPositions = createDraftSafeSelector(state, (store) => {
    // const positions = store.positions
    let result = 0
    // if(positions) {
    //     positions.derivativePositions.forEach(symbolPosistion => {
    //         symbolPosistion.strategyWisePositions.forEach(strategyPosition => {
    //             strategyPosition.basketWisePositions.forEach(basketWisePosition => {
    //                 result += basketWisePosition.positions.filter(p => p.open).length
    //             })
    //         })
    //     })
    //     result += positions.equityPositions.filter(p => p.open).length
    // }
    return result
})
export const selectSymbolWisePositions = createDraftSafeSelector(state, (store) => ({ derivativePositions: [], equityPositions: [] }))
export const selectQuickOrderData = createDraftSafeSelector(state, (store) => store.quickOrder)
export const selectBasketAnalyzeDetails = createDraftSafeSelector(state, (store) => store.basketAnalyzeDetails)
export const selectConnectTradingAccount = createDraftSafeSelector(state, (store) => store.connectTradingAccount)
export const selectSelectedStrategy = createDraftSafeSelector(state, (store) => store.selectedStrategy)
export const selectConnectTradingAccountType = createDraftSafeSelector(state, (store) => store.connectTradingAccount.type);